import React from "react";
import TextAreaAutosize from 'react-textarea-autosize';
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, TranslationKeyType, IlistInputOperation, ISelectCardOption, ICardToListOptionType } from "../../../constants/types";

import './ListInputOperation.scss'
import Icon from "../../icon/Icon";

const filterThreshhold = 8;
interface Props extends WithTranslation {
    operation: IlistInputOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};
interface State {
    showInfoText: boolean;
    searchText: string;
};

class ListInputOperation extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            showInfoText: false,
            searchText: ""
        }
    }

    componentDidMount() {
        const { data, onChange } = this.props;
        this.setState({ showInfoText: "condominium" == data?.value })
    }

    onSelectSuggestion = (value: string) => {
        const { data, onChange } = this.props;

        onChange({
            ...data,
            value: value,
            OK: Boolean(value)
        });
        this.setState({ showInfoText: "condominium" == value })
    }

    renderTextInformation() {
        const { t, data } = this.props;
        return <div
            className="card-to-list-suggestion fade-in"
            style={{
                marginTop: "1rem",
                backgroundColor: "whitesmoke",
                padding: "0.5rem",
                borderRadius: "0.25rem",
            }}>
            {t("form-strings.condominium-or-tenancy.info-condominium" as unknown as TemplateStringsArray)}
        </div >
    }

    renderSuggestions(suggestions: ICardToListOptionType[]) {
        const { t, data } = this.props;
        const searchText = this.state.searchText.toLocaleLowerCase();
        
        const filterData = suggestions.length > filterThreshhold;

        const suggestionElems = suggestions.map(suggestion => {
            const suggestionString = t(suggestion.text as unknown as TemplateStringsArray) as string;

            if (filterData && !(suggestionString.toLocaleLowerCase().includes(searchText))) {
                return null;
            }

            return (
                <Col key={suggestion.key}
                    xs={12}
                    className="card-to-list-suggestion fade-in"
                    aria-selected={suggestion.key === data?.value}
                    onClick={() => this.onSelectSuggestion(suggestion.key)}
                >
                    <div key={suggestion.key} className="card-to-list-suggestion-checkmarker">
                        <Icon key={suggestion.key} type={"CHECKMARK"} iconProps={{ size: '1.5rem' }} />
                    </div>
                    {suggestionString}
                </Col>);
        }).filter(e => e != null);

        return <Row className="card-to-list-suggestions">
            { filterData ? 
                <Col key={'list-search'} xs={12} className="fade-in">
                    <TextAreaAutosize className="search-text-input" value={searchText} onChange={(e) => this.setState({searchText: e.target.value})} placeholder={t("general.search")}/>
                </Col>
            : null }
            {suggestionElems}
            {suggestionElems.length == 0 ?
                <Col key={'list-search-no-match'} xs={12} className="fade-in search-text-input-no-result" >
                    {t("general.search-no-match")}
                </Col>
            : null}
            {this.state.showInfoText && this.renderTextInformation()}
        </Row>
    }


    render() {
        const { t, operation, data } = this.props;

        return <div className="render-list-input-operation">
            <p className="card-to-list-description fade-in">{t(operation.description as unknown as TemplateStringsArray)}</p>
            {this.renderSuggestions(operation.suggestions)}
        </div>;
    }
};

export default withTranslation()(ListInputOperation);